// src/config.js
const API_URL = "https://api.scribebot.net";
//const API_URL = "http://localhost:8000";
const GOOGLEMAPKEY = "AIzaSyAOggHXBp1ky0rfbQuzcwsaq1efbHo1Mog";
export { API_URL, GOOGLEMAPKEY };
